import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const TrustStrip = () => {
  const containerRef = useRef(null);
  const textRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Horizontal scroll parallax effect
      gsap.fromTo(textRef.current,
        { x: -50 },
        { 
          x: 50, 
          ease: 'none',
          scrollTrigger: {
            trigger: containerRef.current,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1 // smooth scrubbing effect
          }
        }
      );
    });

    return () => ctx.revert();
  }, []);

  return (
    <div ref={containerRef} className="border-y border-slate-100 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/50 backdrop-blur-sm py-8 relative z-10 transition-colors duration-300 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <p className="text-center text-sm font-medium text-slate-500 dark:text-slate-400 uppercase tracking-widest mb-6">
          Trusted by businesses across industries
        </p>
        <div ref={textRef} className="flex flex-wrap justify-center md:flex-nowrap gap-8 md:gap-16 items-center opacity-60 grayscale hover:grayscale-0 transition-all duration-500 w-[120%]">
          <span className="text-lg font-bold text-slate-400 whitespace-nowrap">MANUFACTURING</span>
          <span className="text-lg font-bold text-slate-400 whitespace-nowrap">RETAIL</span>
          <span className="text-lg font-bold text-slate-400 whitespace-nowrap">HEALTHCARE</span>
          <span className="text-lg font-bold text-slate-400 whitespace-nowrap">LOGISTICS</span>
          <span className="text-lg font-bold text-slate-400 whitespace-nowrap">FINANCE</span>
          <span className="text-lg font-bold text-slate-400 whitespace-nowrap">AUTOMOTIVE</span>
        </div>
      </div>
    </div>
  );
};

export default TrustStrip;